import BButton from 'components/common/BButton';
import BSkeleton from 'components/common/BSkeleton';
import CurrencyText from 'components/common/CurrencyText';
import Modal from 'components/common/Modal';
import Breakpoint from 'components/Layout/Breakpoint';
import useTranslation from 'next-translate/useTranslation';
import { FunctionComponent, ReactNode, useCallback, useState } from 'react';
import { ExperienceSession } from 'types/experience/experience-session.type';

interface ExperiencePriceWidgetMobileProps {
  children: ReactNode;
  sessionsLoading: boolean;
  sessions: ExperienceSession[];
}

const ExperiencePriceWidgetMobile: FunctionComponent<
  ExperiencePriceWidgetMobileProps
> = ({ children, sessionsLoading, sessions }) => {
  const { t } = useTranslation('experience');
  const [show, setShow] = useState<boolean>(false);

  const openModal = useCallback(() => {
    setShow(true);
  }, []);

  return (
    <Breakpoint type="max" bp="MD">
      <section className="fixed bottom-0 left-0 z-400 flex h-[var(--bottom-navigation-menu-height)] w-full items-center justify-between border bg-white px-[var(--padding-container-x)] py-2 shadow-t-lg">
        <div>
          <div className="h-6">
            {sessionsLoading ? (
              <BSkeleton className="h-6 w-36" />
            ) : sessions[0]?.price.amount ? (
              <>
                <CurrencyText
                  price={sessions[0].price.amount}
                  currency={sessions[0].price.currency}
                  className="text-lg"
                />
                <span className="ml-1 inline-block text-slate-500">
                  /{t('common:units.headCount')}
                </span>
              </>
            ) : null}
          </div>
        </div>
        <div className="mx-0">
          <BButton
            className="!py-3"
            onClick={openModal}
            disabled={sessionsLoading}
          >
            {t('priceWidget.mobile.seeDates')}
          </BButton>
        </div>
        <Modal show={show} setShow={setShow} hideWithCss>
          {children}
        </Modal>
      </section>
    </Breakpoint>
  );
};

export default ExperiencePriceWidgetMobile;
